///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { createSlice } from "@reduxjs/toolkit";
import { postSpotLegs } from "../api/api";
import { mapStateToSpotLegs } from "../helpers/adHocHelpers";
import types from "../helpers/types";

export const initialState = {
  requestStatus: types.requestStatuses.initial,
  loadOrigin: null,
  loadOriginSort: null,
  loadDestination: null,
  loadDestinationSort: null,
  movementOrigin: null,
  movementDestination: null,
  scheduledDeparture: null,
  scheduledArrival: null,
  serviceLevel: null,
  trailerType: null,
  driverType: null,
  numberOfLegs: null,
  requirements: [],
  legs: {},
  formStep: 1,
};

const adHocSlice = createSlice({
  name: "adHocSlice",
  initialState,
  reducers: {
    updateFormValue: (state, { payload }) => {
      state[payload.key] = payload.value;
    },
    updateAdditonalLegValue: (state, { payload }) => {
      state.legs[payload.key] = payload.value;
    },
    requestBuildAdHoc: (state) => {
      state.requestStatus = types.requestStatuses.inProgress;
    },
    receiveBuildAdHocSuccess: (state) => {
      state.requestStatus = types.requestStatuses.success;
    },
    receiveBuildAdHocFailure: (state) => {
      state.requestStatus = types.requestStatuses.failure;
    },
    resetBuildAdhoc: () => {
      return { ...initialState };
    },
  },
});

export const {
  updateFormValue,
  updateAdditonalLegValue,
  requestBuildAdHoc,
  receiveBuildAdHocSuccess,
  receiveBuildAdHocFailure,
  resetBuildAdhoc,
} = adHocSlice.actions;

export const buildAdHoc = (setSuccessOpen) => async (dispatch, getState) => {
  const { adHoc } = getState();

  dispatch(requestBuildAdHoc());
  try {
    const data = mapStateToSpotLegs(adHoc);
    await postSpotLegs(data);
  } catch (e) {
    dispatch(receiveBuildAdHocFailure());
    return;
  }
  dispatch(receiveBuildAdHocSuccess());
  setSuccessOpen(true);
};
export const adHocReducer = adHocSlice.reducer;
